<template>
  <div class="ground-page" ref="ground">
    <div style="background: #fff">
      <nav ref="nav">
        <div class="nav">
          <span @click="curTab = 0" :class="{'active': curTab == 0}">校园招聘</span>
          <span @click="curTab = 1" :class="{'active': curTab == 1}">社会招聘</span>
        </div>
      </nav>
      <div class="grounds-wrapper" >
        <div class="grounds" :style="groundsWidth" :class="curTabOffset">
          <Ground place="school" :selector="[ 'func','degree']" >
            <div class="banner">
              <img src="../assets/banner.png" alt="">
            </div>
          </Ground>
          <Ground place="social" :selector="[ 'func','degree']">
            <div class="banner">
              <img src="../assets/banner.png" alt="">
            </div>
          </Ground>
        </div>
      </div>
    </div>
    <BackHome />
  </div>
</template>

<script>
import Ground from '@/components/Ground'
import BScroll from 'better-scroll'
import BackHome from '../components/BackHome.vue'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
  name: 'Home',
  data() {
    return {
      scroll: null,
      scroll2: null,
      curTab: null,  // 当前标签页
      tabCnt: 4,
      swiperOption: [
        {
          autoplay: true,
          pagination: {
            el: '.banner-pagination-1',
            bulletClass : 'bullet',
            bulletActiveClass: 'bullet-active',
          },
        },
        {
          autoplay: true,
          pagination: {
            el: '.banner-pagination-2',
            bulletClass : 'bullet',
            bulletActiveClass: 'bullet-active',
          },
        },
        {
          autoplay: true,
          pagination: {
            el: '.banner-pagination-3',
            bulletClass : 'bullet',
            bulletActiveClass: 'bullet-active',
          },
        },
      ]
    }
  },
  computed: {
    curTabOffset() {
      return 'cur-tab-' + this.curTab
    },
    groundsWidth() {
      return `width: ${this.tabCnt}00%`
    }
  },
  methods: {
    disableScroll() {
      // console.log('外部停止')
      if(this.scroll.enabled) this.scroll.disable()
    },
    enableScroll() {
      // console.log('外部启动')
      if(!this.scroll.enabled) this.scroll.enable()
    },
    scrollToList(callback) {
      this.scroll.scrollToElement('.selector-bar', 300)
      if(callback) callback();
    }
  },

  mounted() {
    // 初始化home页为 scroll-wrapper
    this.$nextTick( () => {
      // 初始化 betterScroll
      this.scroll = new BScroll(this.$refs.ground,{
        click: true,
        momentumLimitTime: 250,
        bounceTime: 250,
        bounce: { bottom: false, }
      })
      // 默认禁用joblist滚动
      this.$eventBus.emit('jobListScrollDisable')

      // 当外部滚动触底,内部滚动开启
      this.scroll.on('scrollEnd', e => {
        if(e.y <= this.scroll.maxScrollY) {
          this.$eventBus.emit('jobListScrollEnable')
        } else {
          this.$eventBus.emit('jobListScrollDisable')
        }
      })
    })
    this.curTab = this.$route.params.initTab;
    this.scroll2 = new BScroll(this.$refs.nav,{
      scrollY: false,
      scrollX: true,
      click: true,
      momentumLimitTime: 250,
      bounceTime: 250,
      // bounce: { bottom: false, }
    })
  },
  created() {
    this.curTab = this.$route.params.initTab || 0
    // 注册全局滚动事件接口
    this.$eventBus.on('homeScrollDiable', this.disableScroll)
    this.$eventBus.on('homeScrollEnable', this.enableScroll)
    this.$eventBus.on('homeScrollToList', this.scrollToList)
    
    // 调用数据接口获取数据
    this.$store.commit('jobListGetBySelector', {place: 'school'})
    this.$store.commit('jobListGetBySelector', {place: 'social'})
  },
  // keepAlive生命周期钩子
  activated() {
    if(this.$route.params.initTab !== undefined) this.curTab = this.$route.params.initTab
    if(this.scroll) this.$eventBus.emit('scrollRefresh')
  },
  components: {
    Ground, BackHome, swiper, swiperSlide
  }
}
</script>

<style lang="scss">
  .ground-page { padding: 0 16px; font-size: 0; height: 100vh;
    .banner { height:360px; border-radius: 8px; overflow: hidden; position: relative; font-size: 0;
      img { width: 100%; height: 100%; border-radius: 8px; }
      .banner-pagination { position: absolute; bottom: 22px; width: 100%; text-align: center; z-index: 10;
        .bullet { margin-left: 8px; display: inline-block; width:20px; height:4px; background:rgba(255,255,255,1); opacity: 0.5;
          &:first-child { margin-left: 0; }
        }
        .bullet-active { opacity: 1; }
      }
    }
    > div > nav {
      > div { display:inline-block; height: 76px; font-size:28px; color:rgba(153,153,153,1); line-height: 76px; white-space: nowrap; }
      span { position: relative; margin-left: 60px;
        &:first-child {margin-left: 0}
        &.active { font-weight: 600; color:#0075C1;;
          &::after { content: ""; width:40px; height:4px; background:#0075C1;; border-radius:4px; position: absolute; bottom: 10px; left: 0; right: 0; margin: auto; }
        }
      }
    }
    .grounds-wrapper {
      overflow: hidden;
      .grounds {
        display: flex;
        white-space: nowrap;
        transition: all .3s ease;
      }
      .cur-tab-0 { transform: translateX(0px); }
      .cur-tab-1 { transform: translateX(calc(-718px * 1)); }
      .cur-tab-2 { transform: translateX(calc(-718px * 2)); }
      .cur-tab-3 { transform: translateX(calc(-718px * 3)); }
      .cur-tab-4 { transform: translateX(calc(-718px * 4)); }
      .cur-tab-5 { transform: translateX(calc(-718px * 5)); }
    }
  }
  .nav{
    display: flex !important;
    width: 100%;
    justify-content: center;
  }
</style>